import React, { useState, useRef } from 'react';
import { array, string, object } from 'prop-types';
import useOutsideOfReact from '../custom-hooks/useOutsideOfReact';
import useWindowWidth from '../custom-hooks/useWindowWidth';

import HotelsByCountry from './HotelsByCountry';
import googleMaps from '../../api/googleMaps';

function PanelMap({ API_KEY, hotels, theme }) {
  const [country, setCountry] = useState(null);
  const [filteredMap, setFilteredMap] = useState(hotels);
  const [isHidden, setIsHidden] = useState(true);
  const windowWidth = useWindowWidth();
  const mapHeader = useRef(null);
  const mapWrap = useRef(null);

  function selectLocationMap(e) {
    let elValue;
    if (!e.target) {
      elValue = e;

      const selection = hotels.filter(i => i.country === elValue);
      const byCountry = hotels.filter(i => i.country === selection[0].country);

      if (country !== byCountry[0].country) {
        setCountry(byCountry[0].country);
        setFilteredMap(byCountry);
      }
    } else {
      if (e.target.classList.contains('suggestion')) {
        elValue = e.target.querySelector('span').textContent;
      } else {
        elValue = e.target.parentNode.querySelector('span').textContent;
      }

      const selection = hotels.filter(i => i.value === elValue);
      const byCountry = hotels.filter(i => i.country === selection[0].country);

      if (country !== byCountry[0].country) {
        setCountry(byCountry[0].country);
        setFilteredMap(byCountry);
      }
    }
  }

  setTimeout(() => {
    googleMaps.init({
      API_KEY,
      country,
      filteredMap,
      selectLocationMap,
      theme
    });
  }, 0);
   
 
  useOutsideOfReact({
    element: document.getElementById('panel-hotels-label'),
    hook: setIsHidden,
    value: true
  });

  const placesByCountry = {};

  filteredMap.map(place => {
    if (!placesByCountry[place.country]) {
      placesByCountry[place.country] = [];
    }

    placesByCountry[place.country].push(place);
  });

  const groupByCountry = [];
  let group;

  for (group in placesByCountry) {
    groupByCountry.push({
      country: group,
      places: placesByCountry[group]
    });
  }

  function toggleMapContent() {
    const topBar = document.getElementById('top-bar-find-a-hotel');
    setIsHidden(!isHidden);
    // #top-bar-find-a-hotel is outside of React
    topBar.classList.toggle('hidden');
  }

  function resetSearch() {
    setFilteredMap(hotels);
    setCountry(null);
  }

  return (
    <div className="tabs-panel tabs-google-maps" id="panel-destination">
      <div id="map-wrapper">
        <div
          className={!isHidden && windowWidth <= 1024 ? 'hidden' : undefined}
          id="map"
        />
        {country && (
          <button onClick={resetSearch} className="back-to-full-map">
            Back to full map
          </button>
        )}
        <div
          id="map-content"
          className={
            isHidden && windowWidth > 1024 ? 'hide-desktop' : undefined
          }
        >
          <div ref={mapHeader} className="map-contents-header">
            <button
              onClick={toggleMapContent}
              className={
                'map-toggle' +
                (!isHidden && windowWidth <= 1024 ? ' map-content-top' : '') +
                (!isHidden && windowWidth > 1024 ? ' slide' : '')
              }
            >
              <img
                className="map-content-toggle"
                src="/templates/images/icons/icon-arrow-gray-up.svg"
                alt="toggle hotels arrow"
              />
            </button>
            <div className="map-contents-paragraph-wrap">
              <p className="map-contents-paragraph">
                <span>Historic Hotels Worldwide®</span> is a prestigious collection of more than{' '}
                <span>{hotels && hotels.length} Historic Hotels</span> including former castles, chateaus, palaces, academies, haciendas, villas, monasteries, and other historic lodging. 
                <span id="map-contents-paragraph-sub" ></span>
              </p>
            </div>
          </div>
          <div
            ref={mapWrap}
            className={
              'map-contents-wrap' +
              (isHidden && windowWidth <= 1024 ? ' hidden' : '')
            }
          >
            <HotelsByCountry
              filtered={filteredMap}
              groupByCountry={groupByCountry}
              mapHeader={mapHeader}
              mapWrap={mapWrap}
              selectLocationMap={selectLocationMap}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

PanelMap.propTypes = {
  API_KEY: string.isRequired,
  hotels: array.isRequired,
  theme: object
};

export default PanelMap;
